/**
 * @license Highstock JS v12.2.0 (2025-04-07)
 * @module highcharts/highstock
 *
 * (c) 2009-2025 Torstein Honsi
 *
 * License: www.highcharts.com/license
 */
'use strict';
import Highcharts from './highcharts.src.js';
import './modules/stock.src.js';
Highcharts.product = 'Highstock';
export default Highcharts;
